import React, { createRef, useState } from 'react';
import Compose from '../../../components/Compose';
import Box from 'reusecore/src/elements/Box';
import { Counter } from '../../../helpers/Counter';
import { PhoneWrapper } from '../ContactInfoModal/styleInfosModal';
import Icon from '../../../components/Icon';
import Text from 'reusecore/src/elements/Text';
import styled from 'styled-components';
import Button from 'reusecore/src/elements/Button';
import { v4 as uuid } from 'uuid';
import { analytics, db } from '../../../helpers/firebaseHelper';
import { useTranslation } from 'next-i18next';

const MessageModal = ({ ...props }) => {
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);
  const chatInput = createRef();

  const MessageSending = val => {
    setSending(true);
  };

  const send = () => {
    let dateSend = new Date();
    let sendingMsg = {
      _id: uuid(),
      createdAt: dateSend,
      received: true,
      sent: true,
      text: chatInput.current.state.value.trim(),
      user: {
        _id: props.userId,
        name: props.userName,
        avatar: props.avatar,
      },
    };

    db.collection('messages')
      .doc(props.msgActive)
      .collection('data')
      .add(sendingMsg);
    db.collection('messages')
      .doc(props.msgActive)
      .update({
        hasLast: true,
        showing: { [props.advertiser]: true, [props.sender]: true },
        last: {
          ...sendingMsg,
          createdAt: dateSend,
          read: false,
          unreadFor:
            props.advertiser === props.userId ? props.sender : props.advertiser,
        },
      });
    setSending(true);

    if (
      props.hasOwnProperty('first') &&
      props.first === true &&
      props.hasOwnProperty('postId')
    ) {
      // Initialize the sharded counter.
      const conversations = new Counter(
        db.collection('ads').doc(props.postId),
        'stats.conversations'
      );

      // Increment the field "favorites" of the document
      conversations.incrementBy(1);
    }

    // analytics
    if (analytics) {
      analytics.logEvent('conversation_start', {
        platform: 'web',
        id: props.postId,
      });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        flexBox
        style={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          paddingTop: 20,
          paddingBottom: 40,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <PhoneWrapper>
          <Icon name="ios-chatbubbles" fontSize={32} color="#fff" mr={10} />
        </PhoneWrapper>

        <MessageTitleWrapper>
          {t('adsView.sidebar.contact.modal.title')}
        </MessageTitleWrapper>
      </Box>
      {!sending && (
        <>
          <Compose
            {...props}
            ref={chatInput}
            callBackSend={MessageSending}
            sendWithButton={true}
          />
          <FlexContainer>
            <Box>
              <></>
            </Box>
            <Button
              title="Envoyer"
              fontSize={12}
              className="primary"
              bg="#00BCD4"
              style={{
                fontSize: 15,
                fontWeight: 'bold',
              }}
              onClick={send}
            />
          </FlexContainer>
        </>
      )}
      {sending && (
        <Text
          content={t('adsView.sidebar.contact.modal.success')}
          as="span"
          fontSize={18}
          fontWeight={400}
          color="#51bdd5"
          style={{
            border: '1px solid #51bdd5',
            padding: 14,
            background: 'white',
            borderRadius: '2px',
          }}
          mb={3}
        />
      )}
      <Box
        flexBox
        style={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          backgroundColor: '#F8F8F8',
          marginTop: 20,
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <Text
          content={t('report.report')}
          as="span"
          fontSize={16}
          fontWeight={700}
          color="#333333"
          mb={10}
        />

        <Text
          content={t('report.contact')}
          as="span"
          fontSize={14}
          fontWeight={400}
          color="#595959"
          mb={3}
        />
        <a
          style={{ textAlign: 'center' }}
          href={`mailto:${process.env.MAIL_FROM_EMAIL}`}
        >
          {process.env.MAIL_FROM_EMAIL}
        </a>
      </Box>
    </div>
  );
};

export default MessageModal;

const MessageTitleWrapper = styled.a`
  margin: auto;
  font-size: 22px;
  margin-top: 22px;
  text-align: center;
  display: flex;
  &:hover {
    color: black;
  }
`;
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;
